import React from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from 'react-jss';

const ALIGNMENT = {
  LEFT_TOP: 'left',
  RIGHT_TOP: 'right',
  CENTER: 'center',
};

const useStyles = createUseStyles({
  logoContainer: {
    margin: [0, 40],
    padding: [40, 0],
  },
  logoAlignment: {
    textAlign: ({ logo }) => ALIGNMENT[logo?.verticalAlignment],
  },
  logoImage: {
    height: ({ logo }) => (logo?.size ? logo?.height : 'auto'),
    width: ({ logo }) => (logo?.size ? logo?.width : undefined),
    maxWidth: '100%',
  },
});

const Logo = ({ logo }) => {
  const url = logo?.image?.url;
  const { logoAlignment, logoContainer, logoImage } = useStyles({ logo });

  if (logo?.enabled) {
    return (
      <div className={`${logoContainer} ${logoAlignment}`} data-testid="Logo__Container">
        <img src={url} className={logoImage} alt="Survey Logo" />
      </div>
    );
  }
  return null;
};

Logo.propTypes = {
  logo: PropTypes.shape({
    height: PropTypes.number,
    size: PropTypes.string,
    image: PropTypes.shape({
      url: PropTypes.string,
    }),
    verticalAlignment: PropTypes.oneOf(['LEFT_TOP', 'RIGHT_TOP', 'CENTER', 'TOP']),
    width: PropTypes.number,
    enabled: PropTypes.bool,
  }),
};

Logo.defaultProps = {
  logo: null,
};

export default Logo;
